"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M22.162 5.623A11.929 11.929 0 0 1 24 12c0 2.34-.673 4.526-1.836 6.374a.496.496 0 0 1-.081.127 12.096 12.096 0 0 1-3.582 3.582.496.496 0 0 1-.13.082A11.929 11.929 0 0 1 12 24c-2.34 0-4.524-.673-6.371-1.835a.504.504 0 0 1-.133-.084 12.097 12.097 0 0 1-3.576-3.576.497.497 0 0 1-.087-.136A11.929 11.929 0 0 1 0 12c0-2.339.673-4.524 1.835-6.371a.497.497 0 0 1 .082-.13A12.096 12.096 0 0 1 5.5 1.917a.497.497 0 0 1 .13-.082A11.929 11.929 0 0 1 12 0c2.341 0 4.528.674 6.377 1.838.042.02.083.045.12.077a12.096 12.096 0 0 1 3.588 3.588.495.495 0 0 1 .077.12Zm-1.102.146a11.093 11.093 0 0 0-2.829-2.83l-3.645 3.647a6.038 6.038 0 0 1 2.828 2.828L21.06 5.77Zm.543.87-3.807 3.807a5.99 5.99 0 0 1 0 3.109l3.807 3.806A10.932 10.932 0 0 0 23 12c0-1.945-.507-3.773-1.397-5.36Zm-4.854 3.796a5.024 5.024 0 0 0-3.221-3.196A4.982 4.982 0 0 0 12 7a4.983 4.983 0 0 0-1.554.247A5.009 5.009 0 0 0 7 12a5.006 5.006 0 0 0 6.537 4.758l.007-.002a5.023 5.023 0 0 0 3.218-3.23c.155-.482.238-.994.238-1.526a4.983 4.983 0 0 0-.25-1.565Zm.611-8.038A10.932 10.932 0 0 0 12 1c-1.944 0-3.773.507-5.36 1.396l3.807 3.808a5.99 5.99 0 0 1 3.107 0l3.806-3.807ZM5.77 21.06l3.645-3.646a6.038 6.038 0 0 1-2.828-2.828L2.94 18.23a11.093 11.093 0 0 0 2.829 2.83Zm.87.543A10.932 10.932 0 0 0 12 23c1.944 0 3.773-.507 5.36-1.396l-3.807-3.807a5.993 5.993 0 0 1-3.107 0L6.64 21.602ZM2.398 17.36l3.807-3.806a5.99 5.99 0 0 1 0-3.107L2.396 6.64A10.932 10.932 0 0 0 1 12c0 1.945.507 3.773 1.397 5.36Zm18.663.872-3.646-3.646a6.037 6.037 0 0 1-2.83 2.829l3.647 3.646a11.09 11.09 0 0 0 2.829-2.83ZM5.77 2.939a11.093 11.093 0 0 0-2.83 2.83l3.646 3.646a6.038 6.038 0 0 1 2.828-2.829L5.769 2.94Z",
    clipRule: "evenodd"
  })]
});